export default function pictureEmptyValue() {
    return {
        file_id: 0,
        lazy: 0,
        sitemap: false,
        file_name: '',
        params: '',
    }
}
